import {Button} from '@wandb/components';
import {Callout} from '@wandb/weave/components/Callout';
import {TailwindContents} from '@wandb/weave/components/Tailwind';
import React from 'react';

import {useSingleRunBackUrl} from '../../PanelBank/headerControls/useSingleRunBackUrl';

export const SingleRunNotFound = () => {
  const backUrl = useSingleRunBackUrl();
  return (
    <TailwindContents>
      <div className="flex h-full w-full flex-col items-center bg-wb-surface pt-[250px]">
        <Callout className="mb-16" size="small" icon="spiral" color="purple" />
        <div className="text-xl font-semibold">Run not found</div>
        <div className="text-wb-text-secondary mb-16">
          This run does not exist. Please check your URL.
        </div>
        <Button variant="secondary" href={backUrl}>
          Go to workspace
        </Button>
      </div>
    </TailwindContents>
  );
};
